var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 43,
    viewBox: "0 0 55 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.60951 26.91C11.2601 26.91 14.2195 23.9506 14.2195 20.3C14.2195 16.6494 11.2601 13.69 7.60951 13.69C3.95891 13.69 0.999512 16.6494 0.999512 20.3C0.999512 23.9506 3.95891 26.91 7.60951 26.91Z",
    fill: "#5D68B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4795 26.68C47.847 26.68 53.8195 20.7075 53.8195 13.34C53.8195 5.97252 47.847 0 40.4795 0C33.112 0 27.1395 5.97252 27.1395 13.34C27.1395 20.7075 33.112 26.68 40.4795 26.68Z",
    fill: "#5D68B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8295 27.55H0.999512",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2896 41.91L27.4096 28.79L40.5396 41.91H14.2896Z",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.83,
    height: 42.91,
    fill: "white",
    transform: "translate(-0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.c21be584c8bc70c38702e458005dcbd7.svg";
export { ForwardRef as ReactComponent };